<template>
  <div class="diff-form">
    <div class="animated fadeIn">
      <b-row style="margin-top: 2em;">
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong class="text-uppercase">{{ $t('email_template.email_template_diffs') }}&nbsp;<i class="fa fa-angle-double-right"></i>&nbsp;{{ id }}</strong>
              <div class="pull-right">
                <button type="button" class="btn btn-success right" @click="goBack">
                  <i class="fa fa-arrow-left"></i>&nbsp; {{ $t('email_template.go_back_to_template_list') }}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col xl="12" style="padding: 0 0 1em 0;">
                  <div class="pull-left mr-2">
                    <b-input-group v-bind:prepend="$t('email_template.version_label')">
                      <b-form-select v-model="filter.template_version" v-bind:value="filter.template_version"
                                     :options="template_versions">
                      </b-form-select>
                      <span v-if="filter.template_version != 0" style="display: inline-block; padding: 0.5em 0.5em 0.5em 1em;">
                        <span v-if="oldTemplateByWho"><i class="fa fa-angle-double-right"></i>&nbsp;<strong>{{ oldTemplateByWho }}</strong></span>&nbsp;
                        <i class="fa fa-angle-double-right"></i> {{ $t('email_template.compared_to') }} <strong>{{ $t('email_template.current_version').toUpperCase() }}</strong>
                      </span>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-row>
              <b-col cols="12" class="text-left">
                <p style="font-size: 16px;"><strong>{{ $t('email_template.metadata_diffs') }}</strong></p>
              </b-col>
              <b-col cols="12" class="text-center">
                <code-diff
                  :id="`diff_metadata`"
                  :old-string="oldMetadata"
                  :new-string="newMetadata"
                  :outputFormat="'line-by-line'"
                  :isShowNoChange="false"
                  :renderNothingWhenEmpty="false"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="text-left">
                <p style="font-size: 16px;"><strong>{{ $t('email_template.content_diffs') }}</strong></p>
              </b-col>
              <b-col cols="12" class="text-center" v-for="lang of languages">
                <p style="font-size: 16px;padding: 1em;"><strong>{{ lang.text }}</strong></p>
                <div style="overflow: auto;">
                  <code-diff
                    :id="`diff_content_${lang.value}`"
                    :old-string="formatAndBeautifyHtml(oldContent[lang.value])"
                    :new-string="formatAndBeautifyHtml(newContent[lang.value])"
                    :outputFormat="'line-by-line'"
                    :isShowNoChange="false"
                    :renderNothingWhenEmpty="false"
                  />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import codeDiff from 'vue-code-diff'
  import beautify from 'js-beautify';

  let vm = null

  export default {
    props: {
      id: {
        type: [String, Number],
        required: true,
        default: 0
      }
    },
    components: {
      codeDiff
    },
    data: function () {
      const DEFAULT_TEMPLATE_VERSION_FILTER_ITEM = {
        value: 0,
        text: this.$t('email_template.current_version')
      }
      return {
        CONSTANTS: {
          DEFAULT_TEMPLATE_VERSION_FILTER_ITEM
        },
        authUser:  this.$auth.user().user_info.user,
        session: {
          client_uuid: String(localStorage.getItem('clientID')),
          client_id: null,
          lang: String(this.$session.get('lang') || 'en'),
        },
        languages: [],
        isProcessing: false,
        filter: {
          template_version: '0',
        },
        template_versions: [DEFAULT_TEMPLATE_VERSION_FILTER_ITEM],
        oldTemplate: null,
        oldTemplateByWho: null,
        newTemplate: null,
        oldMetadata: '',
        newMetadata: '',
        oldContent: '',
        newContent: ''
      }
    },
    mixins: [],
    computed: {},
    validations () {},
    methods: {
      goBack () {
        this.$router.push({ name: 'email_template_list' })
      },
      getLanguageList() {
        let config = this.$store.getters.config
        for (let i in config.main.language) {
          this.languages.push({
            text: this.$t('common.'+config.main.language[i]),
            value: config.main.language[i]
          })
        }
      },
      formatAndBeautifyHtml(html) {
        return beautify.html(html, {
          indent_size: 2,
          indent_char: ' ',
          wrap_line_length: 80,
          brace_style: 'expand',
          end_with_newline: true
        })
      },
      getEmailTemplateVersions() {
        vm.template_versions = [
          this.CONSTANTS.DEFAULT_TEMPLATE_VERSION_FILTER_ITEM
        ]
        vm.axios.notification.getEmailTemplateVersions(vm.id, function (response) {
          vm.isProcessing = false
          const versionsDataFilterItems = response.data.data.items && response.data.data.items.length > 0 ?
            response.data.data.items.map((item) => {
              const itemElements = item.split('|')
              return {
                value: itemElements[1] || 'N/A',
                text: itemElements[1] ? itemElements[1].split('.')[0] : 'N/A',
                byWho: itemElements[0] || 'N/A'
              }
            }) : []
            vm.template_versions = vm.template_versions.concat(versionsDataFilterItems)
        }, function(error) {
          vm.isProcessing = false
          vm.template_versions = [vm.CONSTANTS.DEFAULT_TEMPLATE_VERSION_FILTER_ITEM]
          vm.filter.template_version = vm.CONSTANTS.DEFAULT_TEMPLATE_VERSION_FILTER_ITEM.value
        })
      },
      getEmailTemplate(isFirstLoad = false) {
        vm.isProcessing = true
        if (!vm.id) return
        vm.axios.notification.getEmailTemplateDetail(vm.id, function (newResponse) {
          vm.isProcessing = false
          vm.newTemplate = vm._.cloneDeep(newResponse.data.data.item)

          if (isFirstLoad) {
            vm.template_version = vm.CONSTANTS.DEFAULT_TEMPLATE_VERSION_FILTER_ITEM.value
            vm.performDiff(vm.oldTemplate, vm.newTemplate)
          } else {
            vm.axios.notification.getEmailTemplateVersionDetails({ id: vm.id, version: vm.filter.template_version }, function (oldResponse) {
              vm.oldTemplate = vm._.cloneDeep(oldResponse.data.data.item)
              vm.performDiff(vm.oldTemplate, vm.newTemplate)
            })
          };
          
        }, function(error) {
          vm.isProcessing = false
          vm.oldTemplate = null
          vm.newTemplate = null
          vm.performDiff(vm.oldTemplate, vm.newTemplate)
        })
      },
      performDiff (oldTemplate, newTemplate) {
        if (oldTemplate && newTemplate) {
          vm.oldMetadata = JSON.stringify({
            name: oldTemplate.name,
            subject: oldTemplate.subject
          }, null, 2)
          vm.oldContent = oldTemplate.content
          vm.newMetadata = JSON.stringify({
            name: newTemplate.name,
            subject: newTemplate.subject
          }, null, 2)
          vm.newContent = newTemplate.content
        } else {
          vm.oldMetadata = ''
          vm.oldContent = ''
          vm.newMetadata = ''
          vm.newContent = ''
        }
      }
    },
    created: function () {
      vm = this
      vm.xToken = this.$auth.user().token
      vm.session.client_id = Number(this._.get(vm.$store.getters.config, 'base.id', 0))

      // Get email templates
      vm.getEmailTemplate(true)
      vm.getEmailTemplateVersions()
      vm.getLanguageList()
    },
    watch: {
      'filter.template_version': function (val) {
      const vm = this;
      if (val !== vm.CONSTANTS.DEFAULT_TEMPLATE_VERSION_FILTER_ITEM.value) {
        vm.getEmailTemplate(false)
        const templateVersion = vm.template_versions.find((item) => item.value === val)
        vm.oldTemplateByWho = templateVersion ? templateVersion.byWho : null;
      } else {
        vm.oldTemplate = null
        vm.oldTemplateByWho = null
        vm.newTemplate = null
        vm.performDiff(vm.oldTemplate, vm.newTemplate)
      }
    },
    },
    updated: function () {},
    mounted: function () {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/admin/email-template/DiffForm.vue